import { useCallback } from "react";
import { ProductionFulfillmentApi, useAPIAction } from "melco-shared-logic";

export const useDeleteInputFormats = () => {
  const [deleteInputFormat] = useAPIAction(
    ProductionFulfillmentApi,
    async (api, id: string) => {
      const data = await api.productionFulfillmentFormatsDelete({ id });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "inputFormats.actions.delete",
    }
  );

  return useCallback(
    async (inputFormatIds: string[]) => {
      const successfullyDeleted: string[] = [];

      for (const inputFormatId of inputFormatIds) {
        try {
          await deleteInputFormat(inputFormatId);
          successfullyDeleted.push(inputFormatId);
        } catch (e) {
          // error handling is already done in useAPIAction
        }
      }

      return successfullyDeleted;
    },
    [deleteInputFormat]
  );
};
